<template>
  <div>
    <v-data-table
      :headers="filteredHeaders"
      :items="filteredList"
      :loading="loading"
      :options.sync="options"
      :items-per-page="options.itemsPerPage"
      :server-items-length="totalFilter"
      no-data-text="ไม่มีรายการ"
      loading-text="กำลังค้นหาข้อมูล.."
      hide-default-footer
      class="filters-table elevation-0">
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ $dayjs(item.createdAt).tz('Asia/Bangkok').format('DD MMMM YYYY | HH:mm') }}
      </template>
      <template v-slot:[`item.downloadCSV`]="{ item }">
        <v-btn
          icon
          :disabled="item.status !== 'active'"
          @click="downloadClick(item.id)">
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.editable`]="{ item }">
        <div v-if="item.promotions.length > 0">
          <v-btn
            v-if="item.promotions.length === 1"
            class="dropdown-btn"
            color="#ffd02a"
            small
            :title="$dayjs(item.promotions[0].createdAt).tz('Asia/Bangkok').format('DD MMMM YYYY | HH:mm')"
            @click="editPromotion(item.promotions[0].id)">
            แสดง
          </v-btn>
          <v-menu
            v-else
            offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="dropdown-btn"
                color="#ffd02a"
                small
                v-bind="attrs"
                v-on="on">
                แสดง
                <span>
                  <v-icon size="18">
                    mdi-menu-down
                  </v-icon>
                </span>
              </v-btn>
            </template>
            <v-list class="promotions-list">
              <v-subheader>โปรโมชั่น</v-subheader>
              <v-list-item
                v-for="(promotion, idx) in item.promotions"
                :key="idx"
                dense
                two-line
                class="promotion-items">
                <v-list-item-content @click="editPromotion(promotion.id)">
                  <v-list-item-title>{{ promotion.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $dayjs(promotion.createdAt).tz('Asia/Bangkok').format('DD MMMM YYYY | HH:mm') }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    :input-value="promotion.status === 'active'"
                    dense
                    @change="changeStatus(promotion.id, { active: promotion.status === 'active', scope: 'some'})" />
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div v-else>
          -
        </div>
      </template>
      <template v-slot:[`item.create`]="{ item }">
        <v-btn
          color="info"
          small
          @click="createPromotion(item.id)">
          สร้าง
        </v-btn>
      </template>
      <template v-slot:[`item.delete`]="{ item }">
        <v-btn
          icon
          @click="deleteFilter(item.id)">
          <v-icon color="error">
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <div v-if="item.status === 'pending'">
          <v-progress-circular
            title="กำลังดำเนินการ.."
            indeterminate
            width="3"
            size="20"
            color="amber" />
        </div>
        <div v-else-if="item.status === 'active'">
          <v-icon
            color="success"
            title="พร้อม">
            mdi-checkbox-marked-circle-outline
          </v-icon>
        </div>
        <div v-else-if="item.status === 'failed'">
          <v-icon
            color="error"
            title="ล้มเหลว">
            mdi-close-circle-outline
          </v-icon>
        </div>
      </template>
      <template v-slot:footer>
        <v-pagination
          v-model="options.page"
          total-visible="5"
          class="pt-5"
          :length="pageCount" />
      </template>
      <template v-slot:[`item.detail`]="{ item }">
        <v-btn
          icon
          small
          @click="detailClick(item.id)">
          <v-icon>
            mdi-format-list-bulleted
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.enablePromotion`]="{ item }">
        <v-switch
          :input-value="checkAllStatusPromotion(item.promotions)"
          dense
          @change="changeStatus(item.promotions[0].filterId, { active: checkAllStatusPromotion(item.promotions), scope: 'many'})" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import FiltersProvider from '@/resources/FiltersProvider'
import PromotionsProvider from '@/resources/PromotionsProvider'

const filtersService = new FiltersProvider()
const promotionsService = new PromotionsProvider()

export default {
  props: {
    searchText: {
      type: String,
      default: ''
    },
    initFilter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      pageCount: 0,
      totalFilter: 0,
      searching: null,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [false]
      },
      filteredHeaders: [
        {
          text: 'สถานะ',
          align: 'center',
          sortable: false,
          value: 'status'
        },
        {
          text: 'วันที่',
          align: 'center',
          sortable: true,
          value: 'createdAt'
        },
        {
          text: 'ชื่อกลุ่ม',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        {
          text: 'ดาวน์โหลดรายชื่อ',
          align: 'center',
          sortable: false,
          value: 'downloadCSV'
        },
        {
          text: 'โปรโมชั่น',
          align: 'center',
          sortable: false,
          value: 'editable'
        },
        {
          text: 'สร้างโปรโมชั่นอัตโนมัติ',
          align: 'center',
          sortable: false,
          value: 'create'
        },
        {
          text: 'รายละเอียด',
          align: 'center',
          sortable: false,
          value: 'detail'
        },
        {
          text: 'สถานะโปรโมชั่น',
          align: 'center',
          sortable: false,
          value: 'enablePromotion'
        },
        {
          text: 'ลบ',
          align: 'center',
          sortable: false,
          value: 'delete'
        }
      ],
      filteredList: [],
      fetchInterval: null
    }
  },
  computed: {
    fetching () {
      return this.filteredList.some((filter) => filter.status === 'pending')
    }
  },
  watch: {
    fetching: {
      handler (val) {
        if (val) {
          this.fetchFilter()
        } else {
          clearInterval(this.fetchInterval)
        }
      }
    },
    options: {
      handler () {
        this.filtersInit(this.options, this.searchText)
      },
      deep: true
    },
    initFilter (val) {
      if (val) {
        this.filtersInit(this.options, this.searchText)
        this.$emit('searched')
      }
    }
  },
  created () {
    this.filtersInit(this.options, this.searchText)
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setModal: 'Style/setModal'
    }),
    fetchFilter () {
      this.fetchInterval = setInterval(() => {
        this.filtersInit(this.options, this.searchText)
      }, 30000)
    },
    editPromotion (id) {
      this.$router.push({ name: 'PromotionAction', params: { action: 'detail', id } })
    },
    createPromotion (filterId) {
      this.$router.push({ name: 'PromotionAction', params: { action: 'create', id: filterId } })
    },
    async deleteFilter (id) {
      this.setModal({
        value: true,
        title: 'ลบตัวกรอง',
        confirmText: 'ลบ',
        cancelText: 'ยกเลิก',
        message: 'คุณต้องการจะลบตัวกรองหรือไม่?',
        confirmOnly: false,
        onConfirm: async () => {
          try {
            const res = await filtersService.deleteByID(id)
            if (res.message === 'done') {
              this.filtersInit(this.options, this.searchText)
              this.setSnackBar({
                value: true,
                message: 'ตัวกรองถูกลบแล้ว',
                type: 'success'
              })
            } else {
              this.setSnackBar({
                value: true,
                message: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
                type: 'error'
              })
            }
          } catch (e) {
            console.error(e)
          }
          this.setModal({ value: false })
        }
      })
    },
    async filtersInit (options, search) {
      this.loading = !this.fetching
      try {
        const { data } = await filtersService.getFiltersWithOptions(options, search)
        this.pageCount = data.pages
        this.totalFilter = data.total
        this.filteredList = data.results.map((segment) => ({
          createdAt: segment.filter.createdAt,
          id: segment.filter.id,
          name: segment.filter.name,
          operators: segment.filter.operators,
          options: segment.filter.options,
          downloadable: true,
          amount: segment.totalUser,
          promotions: segment.promotions,
          status: segment.status
        }))

        this.promotionsInit()
      } catch (e) {
        this.setSnackBar({
          value: true,
          message: `เกิดข้อผิดพลาด ขณะดาวน์โหลด Filter (${e.code})`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    downloadClick (id) {
      this.$emit('download-click', id)
    },
    async promotionsInit () {
      const promotions = await this.fetchPromotions()
      promotions.forEach((promotion) => {
        if (promotion.data.length > 0) {
          const index = this.filteredList.findIndex((filter) => filter.id === promotion.data[0].filterId)
          this.filteredList[index].promotions = promotion.data
        }
      })
    },
    checkAllStatusPromotion (promotions) {
      return promotions.some((promotion) => promotion.status === 'active')
    },
    async changeStatus (id, option) {
      const alert = {
        message: 'มีข้อผิดพลาด',
        type: 'error'
      }

      try {
        let res = null
        if (option.active && option.scope === 'many') {
          const { data } = await promotionsService.pausePromotionsByFilterId(id)
          res = data
        } else if (option.active && option.scope === 'some') {
          const { data } = await promotionsService.pausePromotion(id)
          res = data
        } else if (!option.active && option.scope === 'many') {
          const { data } = await promotionsService.restorePromotionsByFilterId(id)
          res = data
        } else if (!option.active && option.scope === 'some') {
          const { data } = await promotionsService.restorePromotion(id)
          res = data
        }

        if (res) {
          alert.message = 'เปลี่ยนสถานะโปรโมชั่นแล้ว'
          alert.type = 'success'
        } else {
          alert.message = 'ไม่สามารถเปลี่ยนสถานะโปรโมชั่นได้'
          alert.type = 'error'
        }
      } catch (e) {
        alert.message = e
        alert.type = 'error'
      } finally {
        this.promotionsInit()
        this.setSnackBar({
          value: true,
          message: alert.message,
          type: alert.type
        })
      }
    },
    async fetchPromotions () {
      this.loading = true
      const pendingPromotions = []
      let promotions = []
      try {
        this.filteredList.forEach((filter) => {
          pendingPromotions.push(promotionsService.getPromotionsByFilterId(filter.id))
        })

        await Promise.all(pendingPromotions).then((values) => {
          promotions = values
        })
      } catch (e) {
        this.setSnackBar({
          value: true,
          message: `เกิดข้อผิดพลาด ขณะดาวน์โหลดโปรโมชั่น (${e.code})`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }

      return promotions
    },
    detailClick (id) {
      this.$emit('detail-click', id)
    }
  }
}
</script>

<style>
.dropdown-btn {
  width: 60px
}

.promotion-items {
  cursor: pointer;
  background-color: #ffffff;
}

.promotion-items:hover {
  background-color: rgb(246 246 246);
}

.v-application .filters-table.elevation-1 {
  box-shadow: unset !important;
}

.theme--light.v-data-table.filters-table
  tbody
  tr:hover:not(.v-data-table__expanded__content) {
  background: #fff !important;
}

.v-sheet.v-list.promotions-list {
  max-height: 300px;
}

.promotion-items .v-list-item .v-list-item--dense .v-list-item--two-line .theme--light {
  background-color: #fff;
}
</style>
